/* lua.js generated code 0.3.0 */
let Panel = require("clover/panel/CompenPanel")
let CompenButton = xClass("CompenButton", function () {
    return cc.CSLoader.createNode("cocos/homeScene_icon_signIn.csb")
})
CompenButton.prototype.init = function () {
    let self = this

    let btn = UIButton.create(cc.Sprite.createWithSpriteFrameName("homeScene/compen_icon.png"), true)
    let oldBtn = self.getChildByName("icon")
    let pos = oldBtn.getPosition()
    btn.setPosition(pos.x -2, pos.y  + 5)
    btn.setAnchorPoint(oldBtn.getAnchorPoint())
    btn.setScale(0.94)
    // btn.setScaleX(0.7)
    // btn.setScaleY(0.625)
    // btn.setScale(0.625)
    self.addChild(btn, -1)
    oldBtn.removeFromParent(true)
    // let btn = UIButton.create(self.getChildByName("icon"), true)
    btn.on(UIButtonEvent.Click, handler(self, self.onOpenCompen))
    self.btn = btn

    let label = self.getChildByName("txt")
    label.setPositionX(self.getChildByName("txt").getPositionX() - 8)
    label.setString("公告")

    let newText = cc.LabelTTF.create('公告', FONT_DEF.sidebox)
    // newText.x = -5
    newText.y = -47
    label.removeFromParent(true)
    self.addChild(newText, 2, "txt")

    let prompt = cc.Sprite.createWithSpriteFrameName("uilibrary/btn_prompt.png")
    let label2 = cc.Label.createWithSystemFont("", "Arial", 20)
    label2.setAnchorPoint(0.5, 0.5)
    let size = prompt.getContentSize()
    label2.setPosition(size.width / 2, size.height / 2 + 2)
    prompt.addChild(label2)
    prompt.setAnchorPoint(0.5, 0.5)
    prompt.scale = 0.8
    prompt.setPosition(32, 27)
    self.addChild(prompt, 10)
    self.prompt = prompt
    self.prompt.setVisible(false)
    self.promptLabel = label2
    self.isBusy = false
    self.updateCompenButton()
}
CompenButton.prototype.onOpenCompen = function () {
    let self = this
    if (self.isBusy) {
        return
    }
    self.prompt.setVisible(false)
    self.isBusy = true
    let compenList = UserManager.getInstance().compenList
    if ($len(compenList) > 0) {
        self.createCompen()
    }else {
        Toast.make("暂时没有公告哦！", 1, function () {
            self.isBusy = false
        })
    }
}
CompenButton.prototype.updateCompenButton  = function () {
    let self = this
    let compenNum = 0
    if (_G.kIsNewUser) {
        let compenlist = UserManager.getInstance().compenList
        compenNum = Localhost.haveCompenToshow(compenlist, CompenType.compen) > 0 ? 1 : 0
    }
    if (compenNum > 0) {
        self.prompt.setVisible(true)
        self.promptLabel.setString(compenNum)
    }
}
CompenButton.prototype.createCompen = function () {
    let self = this
    let list = UserManager.getInstance().compenList
    let compenData = null
    let compenIndex = 0
    for (let index = 1; index < list.length; index++) {
        let v = list[index];
        if (v.type === CompenType.compen) {
            compenData = v
            compenIndex = index
            break
        }
    }
    if (!compenData) {
        if (!list[1]) {
            Toast.make("暂时没有公告哦！", 1, function () {
                self.isBusy = false
            })
            return
        }else {
            compenData = list[1]
        }
    }

    function onFail() {
        Toast.make("打开面板失败了哦，请重试！", 1, function () {
            self.isBusy = false
        })
    }

    function onSuccess() {
        if (compenIndex !== 0) {
            table.remove(list, compenIndex)
        }
        // let panel = Panel.create(compenData, function () {
        //     self.isBusy = false
        //     _G.isCompenOpened = true
        //     require("clover/scene/HomeScene").getInstance().btnLayer.updateBoxPrompt()
        // })
        // panel.popup()
        Panel.show(compenData, function () {
            self.isBusy = false
            _G.isCompenOpened = true
            require("clover/scene/HomeScene").getInstance().btnLayer.updateBoxPrompt()
        }, function (panel) {
            panel.popup(true)
        }, function () {
            Toast.make(getText("error.tip.load_res_error"), 1, function () {
                self.isBusy = false
            })
        }, function () {
            Toast.make(getText("error.tip.load_canceled"), 1, function () {
                self.isBusy = false
            })
        })
    }

    function nextWindow() {
        let imageUrl = compenData.imageUrl
        if (imageUrl) {
            preloadWithLoading(imageUrl, onSuccess, onFail)
        }else {
            onSuccess()
        }
    }
    nextWindow()
}
CompenButton.prototype.ctor = function () {
    this.init()
}
module.exports = CompenButton